import { render, staticRenderFns } from "./GoodsDetailHandler.vue?vue&type=template&id=296fca6c&"
import script from "./GoodsDetailHandler.vue?vue&type=script&lang=js&"
export * from "./GoodsDetailHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports